function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Agronomist---Stacje_pogodowe",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Strona-Stacji-Pogodowych",
  transform: "translate(-787.000000, -3270.000000)",
  fill: "#E92B5C"
}, React.createElement("g", {
  id: "table",
  transform: "translate(406.000000, 2817.000000)"
}, React.createElement("g", {
  id: "opis"
}, React.createElement("g", {
  transform: "translate(0.000000, 103.000000)"
}, React.createElement("g", {
  id: "lista",
  transform: "translate(0.000000, 86.000000)"
}, React.createElement("g", {
  id: "ICOS",
  transform: "translate(371.000000, 3.000000)"
}, React.createElement("g", {
  id: "ico-copy"
}, React.createElement("g", {
  id: "ico/check-copy-8-ico/x",
  transform: "translate(0.000000, 251.000000)"
}, React.createElement("path", {
  d: "M19.75,10 L22,12.25 L18.249,15.999 L22,19.75 L19.75,22 L15.999,18.249 L12.25,22 L10,19.75 L13.75,15.999 L10,12.25 L12.25,10 L16,13.75 L19.75,10 Z",
  id: "Combined-Shape"
}))))))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/x.0cde0c72.svg";
export { SvgComponent as ReactComponent };